import React, { useEffect, useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Collapse,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import "./SideNavigation.scss";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

// Menu Icons
import DashboardIcons from './../../../../../assets/images/menu-icons/dashboard.svg'
import UserManagementIcons from './../../../../../assets/images/menu-icons/user-management.svg'
import MasterSettingsIcons from './../../../../../assets/images/menu-icons/settings.svg'
import ManageInterviewer from './../../../../../assets/images/menu-icons/manage-interviewer.svg'
import positionTrackerIcon from '../../../../../assets/images/menu-icons/position-tracker.svg'
import interviewCalendarIcon from '../../../../../assets/images/menu-icons/calendar.svg'
import { getUser } from "../../../../../utils/types";
import PositionIcon from '../../../../../assets/images/menu-icons/position-tracker.svg';
import candidateManagementIcon from '../../../../../assets/images/menu-icons/candidate-management.svg';
import documentManagementIcon from '../../../../../assets/images/menu-icons/document-management.svg'
import interViewCalenderIcon from '../../../../../assets/images/menu-icons/interview-calender.svg';
import queryTrackerIcon from '../../../../../assets/images/menu-icons/query-tracker.svg';
import sopAndGuidelineIcon from '../../../../../assets/images/menu-icons/sop-guideline.svg';
import reportManagementIcon from '../../../../../assets/images/menu-icons/report-management.svg';
import interviewTrackerIcon from '../../../../../assets/images/menu-icons/interview-tracker.svg';
import interviewSlotIcon from '../../../../../assets/images/menu-icons/interview-slots.svg'

const dynamicMenus = [
  {
    title: "Dashboard",
    icon: <img src={DashboardIcons} className="logo-img" alt="" />,
    route: "/admin/dashboard",
    slug: "directus_dashboard",
    display: true
  },
  {
    title: "User Management",
    icon: <img src={UserManagementIcons} className="logo-img" alt="" />,
    expandable: true,
    children: [
      {
        title: "Manage User",
        route: "/admin/user-management/manage-user",
        slug: "users"
      },
      {
        title: "Manage Role",
        route: "/admin/user-management/manage-role",
        slug: "roles"
      },
      {
        title: "Manage Interviewer",
        route: "/admin/user-management/manage-interviewer",
        slug: "interviewer"
      },
    ],
  },
  {
    title: "Master Setting",
    icon: <img src={MasterSettingsIcons} className="logo-img" alt="" />,
    expandable: true,
    children: [
      {
        title: "Domain Master",
        route: "/admin/master-setting/domain-master",
        slug: "domain"
      },
      {
        title: "Position Master",
        route: "/admin/master-setting/position-master",

        slug: "position"
      },
      {
        title: "Rule Master",
        route: "/admin/master-setting/rule-master",

        slug: "rule"
      }
    ],
  },
  {
    title: "Interview Tracker",
    icon: <img src={interviewTrackerIcon} className="logo-img" alt="" />,
    route: "/admin/interview-tracker",
    display: true,
  },
  //  {
  //     title: "Rescheduling Tracker",
  //     icon: <img src={interviewTrackerIcon} className="logo-img" alt="" />,
  //     route: "/admin/rescheduling-tracker",
  //     display: true,
  //   },
  {
    title: "Candidate Management",
    icon: <img src={candidateManagementIcon} className="logo-img" alt="" />,
    route: "/admin/candidate-management",
    display:true
  },
  {
    title: "Query Tracker",
    icon: <img src={queryTrackerIcon} className="logo-img" alt="" />,
    route: "/admin/query-tracker",
    slug: "query_tracker",
    children:[]
  },
  {
    title: "Reports",
    icon: <img src={reportManagementIcon} className="logo-img" alt="" />,
    expandable:true,
    display: true,
    children: [
      {
        title: "Position Report",
        route: "/admin/reports/candidate-position-report",
        slug: "position"
      },
      {
        title: "Infracon Report",
        route: "/admin/reports/candidate-infracon-report",
        display:true
      },
      {
        title: "Interviewer Report",
        route: "/admin/reports/candidate-interviewer-report",
        slug: "interviewer"
      },
      {
        title: "Interview Report",
        route: "/admin/reports/candidate-interview-report",
        display: true
      },
      {
        title: "Invoice Report",
        route: "/admin/reports/invoice-report",
        display: true
      }
    ],
  },
  {
    title: "SOP/Guideline",
    icon: <img src={sopAndGuidelineIcon} className="logo-img" alt="" />,
    route: "/admin/sop-guideline",
    display: true
  },
];

const fixedMenus: any = {
  administrator: [
    {
      title: "Dashboard",
      icon: <img src={DashboardIcons} className="logo-img" alt="" />,
      route: "/admin/dashboard",
      slug: "directus_dashboard",
      display: true
    },
    {
      title: "User Management",
      icon: <img src={UserManagementIcons} className="logo-img" alt="" />,
      expandable: true,
      display: true,
      children: [
        {
          title: "Manage User",
          route: "/admin/user-management/manage-user",
          slug: "users",
          display: true,
        },
        {
          title: "Manage Role",
          route: "/admin/user-management/manage-role",
          slug: "roles",
          display: true,
        },
        {
          title: "Manage Interviewer",
          route: "/admin/user-management/manage-interviewer",
          slug: "interviewer",
          display: true,
        },
        // {
        //   title: "Manage NHAI Official",
        //   route: "/admin/user-management/manage-nhai-official",
        //   slug: "nhai_official",
        //   display: true,
        // },
      ],
    },
    {
      title: "Master Setting",
      icon: <img src={MasterSettingsIcons} className="logo-img" alt="" />,
      expandable: true,
      display: true,
      children: [
        {
          title: "Domain Master",
          route: "/admin/master-setting/domain-master",
          slug: "domain",
          display: true,
        },
        {
          title: "Position Master",
          route: "/admin/master-setting/position-master",
          slug: "position",
          display: true,
        },
        {
          title: "Rule Master",
          route: "/admin/master-setting/rule-master",
          slug: "rule",
          display: true,
        },
        {
          title: "Off Day",
          route: "/admin/master-setting/off-day",
          slug: "Off Day",
          display: true
        }
      ],
    },
    {
      title: "Interview Tracker",
      icon: <img src={interviewTrackerIcon} className="logo-img" alt="" />,
      route: "/admin/interview-tracker",
      display: true,
    },
    {
      title: "Rescheduling Tracker",
      icon: <img src={interviewTrackerIcon} className="logo-img" alt="" />,
      route: "/admin/rescheduling-tracker",
      display: true,
    },
    // {
    //   title: "System Logs",
    //   icon: <img src={interviewSlotIcon} className="logo-img" alt="" />,
    //   route: "/admin/system-logs",
    //   display: true,
    // },
    {
      title: "Candidate Management",
      icon: <img src={candidateManagementIcon} className="logo-img" alt="" />,
      route: "/admin/candidate-management",
      display: true,
    },
    {
      title: "Query Tracker",
      icon: <img src={queryTrackerIcon} className="logo-img" alt="" />,
      route: "/admin/query-tracker",
      display: true
    },
    {
      title: "User Manual",
      icon: <img src={documentManagementIcon} className="logo-img" alt="" />,
      route: "/admin/user-manual",
      display: true,
    },
    {
      title: "Reports",
      icon: <img src={reportManagementIcon} className="logo-img" alt="" />,
      expandable:true,
      display: true,
      children: [
        {
          title: "Position Report",
          route: "/admin/reports/candidate-position-report",
          display:true
        },
        {
          title: "Infracon Report",
          route: "/admin/reports/candidate-infracon-report",
          display:true
        },
        {
          title: "Interviewer Report",
          route: "/admin/reports/candidate-interviewer-report",
          display:true
        },
        {
          title: "Interview Slots Report",
          route: "/admin/reports/interview-slot-report",
          display:true
        },
        {
          title: "Interview Report",
          route: "/admin/reports/candidate-interview-report",
          display: true
        },
        {
          title: "Invoice Report",
          route: "/admin/reports/invoice-report",
          display: true
        }
      ],
    },
    {
      title: "SOP/Guideline",
      icon: <img src={sopAndGuidelineIcon} className="logo-img" alt="" />,
      route: "/admin/sop-guideline",
      display: true
    },
  ],
  interviewer:[
    {
      title: "Dashboard",
      icon: <img src={DashboardIcons} className="logo-img" alt="" />,
      route: "/admin/dashboard",
      slug: "directus_dashboard",
      display: true
    },
    {
      title: "Interview Slots",
      icon: <img src={interviewSlotIcon} className="logo-img" alt="" />,
      route: "/admin/interviewer/interview-slots",
      display: true
    },
    {
      title: "Interview Tracker",
      icon: <img src={interviewTrackerIcon} className="logo-img" alt="" />,
      route: "/admin/interviewer/interview-tracker",
      display: true
    },

    {
      title: "Candidate Management",
      icon: <img src={candidateManagementIcon} className="logo-img" alt="" />,
      route: "/admin/interviewer/candidate-management",
      display: true
    },
    {
      title: "Download Invoice",
      icon: <img src={interviewTrackerIcon} className="logo-img" alt="" />,
      route: "/admin/download-invoice",
      display: true
    },
    // {
    //   title: "Report Management",
    //   icon: <img src={reportManagementIcon} className="logo-img" alt="" />,
    //   route: "/admin/report-management",
    //   display: true
    // },
    {
      title: "SOP/Guideline",
      icon: <img src={sopAndGuidelineIcon} className="logo-img" alt="" />,
      route: "/admin/sop-guideline",
      display: true
    },
    
  ],
  candidate:[
    {
      title: "Dashboard",
      icon: <img src={DashboardIcons} className="logo-img" alt="" />,
      route: "/admin/dashboard",
      slug: "directus_dashboard",
      display: true
    },
    {
      title: "Position Tracker",
      icon: <img src={PositionIcon} className="logo-img" alt="" />,
      route: "/admin/position-tracker",
      display: true
    },
    {
      title: "Interview Calendar",
      icon: <img src={interViewCalenderIcon} className="logo-img" alt="" />,
      route: "/admin/interview-calendar",
      display: true
    },
    {
      title: "Interview Tracker",
      icon: <img src={interviewTrackerIcon} className="logo-img" alt="" />,
      route: "/admin/candidate-interview-tracker",
      display: true
    },
    {
      title: "Query Tracker",
      icon: <img src={queryTrackerIcon} className="logo-img" alt="" />,
      route: "/admin/query-tracker",
      display: true
    },
    {
      title: "SOP/Guideline",
      icon: <img src={sopAndGuidelineIcon} className="logo-img" alt="" />,
      route: "/admin/sop-guideline",
      display: true
    },
],
bidder:[
  {
    title: "Dashboard",
    icon: <img src={DashboardIcons} className="logo-img" alt="" />,
    route: "/admin/dashboard",
    slug: "directus_dashboard",
    display: true
  },
  {
    title: "Candidate Pool",
    icon: <img src={candidateManagementIcon} className="logo-img" alt="" />,
    route: "/admin/candidate-pool",
    display: true
  },
  {
    title: "SOP/Guideline",
    icon: <img src={sopAndGuidelineIcon} className="logo-img" alt="" />,
    route: "/admin/sop-guideline",
    display: true
  },
],
nhai_officials:[
  // {
  //   title: "Dashboard",
  //   icon: <img src={DashboardIcons} className="logo-img" alt="" />,
  //   route: "/admin/dashboard",
  //   slug: "directus_dashboard",
  //   display: true
  // },
  {
      title: "Reports",
      icon: <img src={interviewTrackerIcon} className="logo-img" alt="" />,
      route: "/admin/interview-tracker",
      display: true,
    }
]
}

const SideNavigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user: any = getUser()
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [menus, setMenus] = useState<any>([]);
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    let fetchMenus: any[] = []
    if (user?.roles?.role_code === "administrator" || user?.roles?.role_code === "interviewer" || user?.roles?.role_code === "candidate" ||user?.roles?.role_code === "bidder" ||user?.roles?.role_code === "nhai_officials") {
      fixedMenus[user?.roles?.role_code].forEach((res: any) => fetchMenus.push(res))
    } else {
      dynamicMenus.forEach((res: any) => fetchMenus.push(res))
    }
    if (user?.roles?.role_code !== "administrator" && user?.roles?.role_code !== "candidate" && user?.roles?.role_code !== "interviewer"&&user?.roles?.role_code !== "bidder") {
      if (user?.roles?.permisssions?.length > 0) {
        user?.roles?.permisssions?.forEach((item: any) => {
          fetchMenus?.forEach((menu: any) => {
            if (menu?.children?.length === 0) {
              if (menu?.slug === item?.slug_name) {
                menu.display = true
              }
            } else {
              menu?.children?.forEach((menuChildren: any) => {
                if (menuChildren?.slug === item?.slug_name) {
                  menu.display = true
                  menuChildren.display = true
                }
              });
            }
          });
        });
        setMenus(fetchMenus)
      }
    } else {
      setMenus(fetchMenus)
    }
  }, [])

  const handleMenuClick = (title: string) => {
    setOpenMenus((prevOpenMenus) => ({
      ...prevOpenMenus,
      [title]: !prevOpenMenus[title],
    }));
    if (isCollapsed) {
      setIsCollapsed(false);
    }
  };

  const handlerClick = (data: any) => navigate(data?.route);


  const handleCollapseClick = () => {
    setIsCollapsed(!isCollapsed);
    if (!isCollapsed) {
      setOpenMenus({});
    }
  };
  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem("hasRefreshed");
    if (!hasRefreshed) {
      sessionStorage.setItem("hasRefreshed", "true");
      window.location.reload();
    }
  }, []);

  return (
    <Box className={`side-navigation-container ${isCollapsed ? 'collapsed' : ''}`}>
      <List component="nav">
        {menus.map((menuItem: any) => (
          <React.Fragment key={menuItem.title}>
            {!!menuItem?.display && (
              <ListItem onClick={() => !!menuItem.expandable ? handleMenuClick(menuItem.title) : handlerClick(menuItem)} className={`${(location.pathname.includes(menuItem.title.toLowerCase().replace(/ /g, '-'))||location.pathname.includes(menuItem.title.toLowerCase().replace(/\//g, '-'))) ? 'active' : ''} ${menuItem.expandable ? 'expandable-menu-item' : ''}`}>
                {/* <ListItemIcon>{menuItem.icon}</ListItemIcon> */}
                <div style={{ marginRight: "1rem" }} className={`${(location.pathname.includes(menuItem.title.toLowerCase().replace(/ /g, '-'))||location.pathname.includes(menuItem.title.toLowerCase().replace(/\//g, '-'))) ? 'active-logo' : 'inactive-logo'}`}>
                 <Tooltip title={!isCollapsed?"":menuItem.title} placement="right" arrow>
                  {menuItem.icon}
                </Tooltip>
                </div>
                <ListItemText primary={menuItem.title} className={isCollapsed ? 'hidden' : ''} />
                {menuItem.expandable && (openMenus[menuItem.title] ? <ExpandLess /> : <ExpandMore />)}
              </ListItem>
            )}
            {menuItem.expandable && menuItem.children && (
              <Collapse in={openMenus[menuItem.title]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding className="nested">
                  {menuItem.children.map((child: any) => (
                    <>
                      {!!child?.display && (
                        <ListItem key={child.title} className={`child-menu-item ${child?.route && location.pathname.startsWith(child.route) ? 'active' : ''} `} onClick={() => handlerClick(child)}>
                          <ListItemText primary={child.title} className={isCollapsed ? 'hidden' : ''} />
                        </ListItem>
                      )}
                    </>
                  ))}
                </List>
              </Collapse>
            )}
          </React.Fragment>
        ))}
      </List>
      <Box className="collapse-button" onClick={handleCollapseClick}>
        <IconButton className="collapse-icon">
          {!isCollapsed ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
        </IconButton>
      </Box>
    </Box>
  );
};


export default SideNavigation;
